import {Share} from "@material-ui/icons";
import Link from "react-router-dom/Link";
import {homePathGenerator, slugify} from "../../../api-client/core/authentication/utils";
import React from "react";
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import {ReactComponent as List} from "../../../components/Letflow/SvgIcons/list.svg"
import {request} from "../../../api-client";
import PlaylistImage from "../../../assets/img/Letflow/playlist.jpg";
import NoImage from "../../../assets/img/Letflow/no-image.jpg";
import EventManager, {events} from "../../../utils/EventManager";
import AddToPlaylist from "../AddToPlaylist";
import Delete from "@material-ui/icons/Delete";
import { Tooltip } from "@material-ui/core";
import localization from "../../../config/localization";

const makeImage = (element, type) => {
  let image;
  if (type === 'playlists') {
    if (element.created_by_admin) {
      if (element.image) {
        image = request.file.image.makeCroppedUrl(element.image.id, 400, 400)
      } if (element.featuredImage && element.featuredImage.image) {
        image = request.file.image.makeCroppedUrl(element.featuredImage.image.id, 400, 400)
      } else {
        image = PlaylistImage
      }
    } else {
      if (element.featuredImage && element.featuredImage.image) {
        image = request.file.image.makeCroppedUrl(element.featuredImage.image.id, 400, 400)
      } else {
        image = PlaylistImage
      }
    }
  }  else if (element.image) {
    image = request.file.image.makeCroppedUrl(element.image.id, 400, 400)
  } else {
    image = NoImage
  }
  return image
};

const openContentCreatorModal = (creator) => {
  EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {id: creator.id, dataType: "contentCreator", dataName: creator.name, onTagChange: false});
}

const ContentCreatorItem = ({contentCreator, onFavorite, onDelete = false, isPublic = false, onShare = false}) => {
  return(
    <article style={{ width: '100%' }} className="album-grid-cell is-collapsed opacity1">
      <div className="album-grid-img" style={{ width: "100%", padding: '10px' }}>
        <div className="category-item fav-container" style={{ width: "100%", cursor: 'pointer', borderRadius: '50%' }}>
          <Link
            className="photo-container"
            to={homePathGenerator(isPublic ? `bl/${contentCreator.profile_url ? contentCreator.profile_url : contentCreator.hashcode}` : `contenido/${contentCreator.id}-${slugify(contentCreator.name)}`)}
            onClick={e => {
              if(!isPublic) {
                e.preventDefault();
                openContentCreatorModal(contentCreator)
              }
            }}
          >
            <div className="photo" style={{backgroundImage: `url(${makeImage(contentCreator, "contentCreator")})`}} >
            </div>
          </Link>
          <div className="info">
            <Link
              className="title"
              to={homePathGenerator(isPublic ? `bl/${contentCreator.profile_url ? contentCreator.profile_url : contentCreator.hashcode}` : `contenido/${contentCreator.id}-${slugify(contentCreator.name)}`)}
              onClick={e => {
                if(!isPublic) {
                  e.preventDefault();
                  openContentCreatorModal(contentCreator)
                }
              }}
            >
              {contentCreator.name}
            </Link>
          </div>
          {!isPublic &&
            <div className="icons">
              <div className='list'>
                <Tooltip placement="bottom" title={localization.get(contentCreator.favorite ? "soundbar.remove_from_favorites" : "soundbar.add_to_favorites")}>
                  <Star
                    className={`star-icon ${contentCreator.favorite ? "star-icon-active" : ""}`}
                    style={{cursor: "pointer", height: 20,width: 24}} onClick={() => onFavorite(contentCreator.id)}
                  />
                </Tooltip>
              </div>
              <div className='list'>
                {onDelete ?
                  <Tooltip placement="bottom" title={localization.get("remove_from_playlist")}>
                    <Delete 
                      style={{cursor: "pointer", height: 20,width: 24}}
                      onClick={onDelete}
                    />
                  </Tooltip>
                  :
                  <AddToPlaylist
                    id={contentCreator.id}
                    content={"contentCreators"}
                    icon={
                      <Tooltip placement="bottom" title={localization.get("add_to_playlist")}>
                        <List className="creator-item-playlist" style={{cursor: "pointer", marginTop: 1, height: 18,width: 24, stroke: "#ffffff"}}/>
                      </Tooltip>
                    }
                  />
                }
              </div>
              {onShare && 
                <div className='list'>
                  <Tooltip placement="bottom" title={localization.get("share")}>
                    <Share
                      style={{cursor: "pointer", height: 20,width: 24}}
                      onClick={onShare}
                    />
                  </Tooltip>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </article>
  );
}
export default ContentCreatorItem